import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type IniciarSolicitacaoReservaPayload = {
  contatoNome: string;
  contatoSobrenome: string;
  contatoCelular: string;
  contatoEmail: string;

  empreendId: number;
  dataIni: string; // ISO (YYYY-MM-DD ou full ISO)
  dataFim: string; // ISO

  aluguel?: number;
  troca?: number;
  compra?: number;
  venda?: number;

  precoBaseProprietario: number;
  valorPropostoClienteInicial: number;
  validadeDias?: number;
};

export type IniciarSolicitacaoReservaResponse = {
  solicitacaoReservaId: number;
  token: string;
};

export type BuscarHospedesByTokenResponse = {
  hospedes: Array<{
    pessoaId: number;
    nome: string;
    sobrenome: string;
    cpf: string;
    dataNascimento: string | null; // ou Date, depende do seu backend
    titular: boolean;
  }>;
};
export type SalvarAceiteTermosPorTokenPayload = {
  aceitouTermosUso: boolean;
  aceitouPoliticaPrivacidade: boolean;
  aceitouTermoTaxa: boolean;
};


export const iniciarSolicitacaoReservaService = async (
  payload: IniciarSolicitacaoReservaPayload
): Promise<IniciarSolicitacaoReservaResponse | null> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/iniciar-solicitacao-reserva`;
  console.log("Payload para iniciar solicitação de reserva:", payload);

  try {
    const response = await axios.post(URL, payload, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    console.log("Resposta do servidor ao iniciar solicitação de reserva:", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export type StatusSolicitacaoReserva =
  | "CRIADA"
  | "INICIADA"
  | "AGUARDANDO_PAGAMENTO_TAXA"
  | "TAXA_PAGA"
  | "EM_VERIFICACAO"
  | "PAGAMENTO_TX_INTERROMPIDO"
  | "RESERVA_CONFIRMADA"
  | "RESERVA_FINALIZADA"
  | "RESERVA_CANCELADA"
  | "SEM_INTERESSE_PERIODO_PROCURADO"
  | "SEM_INTERESSE_PERIODO_ENCONTRADO";

export type SolicitacaoReservaFlowCode =
  | "SOLICITACAO_RESERVA_INVALIDA"
  | "PAGAMENTO_TAXA_INTERROMPIDO";

export type SolicitacaoReservaActionRequired =
  | "ENCERRADA"
  | "AGUARDAR_NOVA_ANALISE";

export type SolicitacaoReservaFlowError = {
  code: SolicitacaoReservaFlowCode;
  message: string;
  statusSolicitacaoReserva?: StatusSolicitacaoReserva | null;
  actionRequired?: SolicitacaoReservaActionRequired | null;
};

export type SolicitacaoReservaServiceResult<T> =
  | { ok: true; data: T }
  | { ok: false; error: SolicitacaoReservaFlowError | null; message?: string | null };

export type PeriodoProcuradoPublico = {
  dataIni?: string | null;
  dataFim?: string | null;
  periodoProcuradoIni?: string | null;
  periodoProcuradoFim?: string | null;
  checkinProcurado?: string | null;
  checkoutProcurado?: string | null;
  checkin?: string | null;
  checkout?: string | null;
  inicio?: string | null;
  fim?: string | null;
};

export type PeriodoEncontradoPublico = {
  checkin?: string | null;
  checkout?: string | null;
  noites?: number | null;
  origemDisp?: string | null;
  dispId?: number | null;
};

export type BuscarSolicitacaoPorTokenResponse = {
  periodoProcura?: PeriodoProcuradoPublico | null;
  periodoEncontrado?: PeriodoEncontradoPublico | null;
  periodoProcurado?: PeriodoProcuradoPublico | null;
  solicitacaoReserva: {
    id: number;
    token: string;
    active?: boolean | number | null;
    contatoNome: string;
    contatoSobrenome: string;
    contatoCelular: string;
    contatoEmail: string;
    periodoProcura?: PeriodoProcuradoPublico | null;
    periodoEncontrado?: PeriodoEncontradoPublico | null;
    periodoProcurado?: PeriodoProcuradoPublico | null;
    dataIni?: string | null;
    dataFim?: string | null;
    periodoProcuradoIni?: string | null;
    periodoProcuradoFim?: string | null;
    checkinProcurado?: string | null;
    checkoutProcurado?: string | null;
    formaPagamentoPreferida?: "PIX" | "CARTAO" | null;
    status?: StatusSolicitacaoReserva | null;

    aceitouTermosUso?: boolean | null;
    aceitouPoliticaPrivacidade?: boolean | null;
    aceitouTermoTaxa?: boolean | null;
    aceiteTermosEm?: string | null;
    dataPagamentoTaxa?: string | null;
    pagamentoTaxaEm?: string | null;
    taxaPagaEm?: string | null;
    statusTaxaPagaEm?: string | null;
    prazoBuscaFinal?: string | null;
    prazoFinalBusca?: string | null;
    prazoAnaliseFinalEm?: string | null;
    prazoFinalAnaliseEm?: string | null;
    limiteAnaliseEm?: string | null;
  };
};
export type SalvarFormaPagamentoByTokenPayload = {
  formaPagamento: "PIX" | "CARTAO";
};
export type AtualizarStatusSolicitacaoReservaPayload = {
  status: StatusSolicitacaoReserva;
};
export type AtualizarContatoSolicitacaoPayload = {
  contatoNome: string;
  contatoSobrenome: string;
  contatoCelular: string; // +E164
  contatoEmail: string;
};
export type ResumoEstadiaByTokenResponse = {
  empreendimento: { id: number; nome: string };
  checkin: string;   // ISO
  checkout: string;  // ISO
  noites: number;
  periodoProcura?: PeriodoProcuradoPublico | null;
  periodoEncontrado?: PeriodoEncontradoPublico | null;
  periodoProcurado?: PeriodoProcuradoPublico | null;

  valorBaseEstimado: number;
  precificacaoCalculadaEm: string;

  taxaCondicional: number;
  linkPagamentoTaxa?: string | null;
  pagamentoTaxa?: {
    linkPagamento?: string | null;
    status?: PagamentoTaxaCheckoutStatus | null;
    linkPagamentoExpiraEm?: string | null;
    gateway?: string | null;
  } | null;
  pagamentoTaxaElegivel?: boolean;
  pagamentoTaxaLinkDinamicoDisponivel?: boolean;
  pagamentoTaxaGatewayConfigurado?: boolean;
  pagamentoTaxaMotivo?: string | null;

  pix: {
    total: number;
    descontoMin: number;
    totalRestante: number;
  };

  cartao: {
    totalBruto: number;
    ajusteComercial: number;
    totalFinal: number;
    parcelas: number;
    valorParcela: number;

    totalRestanteFinal: number;
    valorParcelaRestante: number;
  };
   limitePosCheckin?: {
    status: "LIBERADO" | "BLOQUEADO";
    parcelasPosRegra: number;
    parcelasPosPermitidas: number;
    valorPosCheckin: number;
    limiteDisponivel: number;
    mensagem: string;
  };


  observacaoValorPodeMudar: boolean;
  mensagemValorPodeMudar?: string;
};

export type SalvarAceiteTermosPorTokenResponse = {
  linkPagamentoTaxa?: string | null;
  pagamentoTaxa?: {
    linkPagamento?: string | null;
    status?: PagamentoTaxaCheckoutStatus | null;
    linkPagamentoExpiraEm?: string | null;
    gateway?: string | null;
  } | null;
  message?: string | null;
  statusSolicitacaoReserva?: StatusSolicitacaoReserva | null;
};

export type PagamentoTaxaCheckoutStatus =
  | "PENDENTE"
  | "RECEBIDO"
  | "VENCIDO"
  | "CANCELADO";

export type BuscarPagamentoTaxaByTokenResponse = {
  linkPagamento: string | null;
  gateway?: string | null;
  status?: PagamentoTaxaCheckoutStatus | null;
  linkPagamentoExpiraEm?: string | null;
  pagamentoTaxa?: {
    linkPagamento?: string | null;
    status?: PagamentoTaxaCheckoutStatus | null;
    linkPagamentoExpiraEm?: string | null;
    gateway?: string | null;
  } | null;
};

const SOLICITACAO_RESERVA_INVALIDA_MSG =
  "Essa solicitação de reserva não está mais válida. Qualquer dúvida entre em contato.";

const PAGAMENTO_TAXA_INTERROMPIDO_MSG =
  "Não podemos te atender agora, mas estamos procurando outro período para você.";

const toSolicitacaoReservaFlowError = (
  payload: any
): SolicitacaoReservaFlowError | null => {
  if (!payload || typeof payload !== "object") return null;

  const code = payload.code;
  const statusSolicitacaoReserva = payload.statusSolicitacaoReserva;

  if (code === "SOLICITACAO_RESERVA_INVALIDA") {
    return {
      code,
      message:
        typeof payload.message === "string" && payload.message.trim().length > 0
          ? payload.message
          : SOLICITACAO_RESERVA_INVALIDA_MSG,
      statusSolicitacaoReserva: null,
      actionRequired:
        payload.actionRequired === "ENCERRADA" ? payload.actionRequired : "ENCERRADA",
    };
  }

  if (
    code === "PAGAMENTO_TAXA_INTERROMPIDO" ||
    statusSolicitacaoReserva === "PAGAMENTO_TX_INTERROMPIDO"
  ) {
    return {
      code: "PAGAMENTO_TAXA_INTERROMPIDO",
      message:
        typeof payload.message === "string" && payload.message.trim().length > 0
          ? payload.message
          : PAGAMENTO_TAXA_INTERROMPIDO_MSG,
      statusSolicitacaoReserva: "PAGAMENTO_TX_INTERROMPIDO",
      actionRequired:
        payload.actionRequired === "AGUARDAR_NOVA_ANALISE"
          ? payload.actionRequired
          : "AGUARDAR_NOVA_ANALISE",
    };
  }

  return null;
};

const extractApiMessage = (payload: any): string | null => {
  if (!payload || typeof payload !== "object") return null;

  if (typeof payload.message === "string" && payload.message.trim().length > 0) {
    return payload.message;
  }

  return null;
};

export const buscarSolicitacaoReservaPorTokenService = async (
  token: string
): Promise<SolicitacaoReservaServiceResult<BuscarSolicitacaoPorTokenResponse>> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}`;

  try {
    const response = await axios.get(URL, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });
    const flowError = toSolicitacaoReservaFlowError(response.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    return { ok: true, data: response.data };
  } catch (error: any) {
    const flowError = toSolicitacaoReservaFlowError(error?.response?.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.error(error);
    return { ok: false, error: null, message: extractApiMessage(error?.response?.data) };
  }
};
export const salvarFormaPagamentoPorTokenService = async (
  token: string,
  payload: SalvarFormaPagamentoByTokenPayload
): Promise<boolean> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/forma-pagamento`;
  try {
    await axios.patch(URL, payload); // rota pública por token
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};



export const atualizarContatoSolicitacaoReservaService = async (
  solicitacaoReservaId: number,
  payload: AtualizarContatoSolicitacaoPayload
): Promise<boolean> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${solicitacaoReservaId}`;

  try {
    await axios.patch(URL, payload, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });
    return true;
  } catch (error: any) {
        console.error("buscarSolicitacaoReservaPorTokenService", {
          status: error?.response?.status,
          data: error?.response?.data,
          message: error?.message,
        });
  return false;
}
};

export const atualizarStatusSolicitacaoReservaService = async (
  solicitacaoReservaId: number,
  payload: AtualizarStatusSolicitacaoReservaPayload
): Promise<boolean> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${solicitacaoReservaId}/status`;

  try {
    await axios.patch(URL, payload, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });
    return true;
  } catch (error: any) {
    console.error("atualizarStatusSolicitacaoReservaService", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    return false;
  }
};

export const atualizarStatusSolicitacaoReservaPorTokenService = async (
  token: string,
  payload: AtualizarStatusSolicitacaoReservaPayload
): Promise<boolean> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/status`;

  try {
    await axios.patch(URL, payload);
    return true;
  } catch (error: any) {
    console.error("atualizarStatusSolicitacaoReservaPorTokenService", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    return false;
  }
};

export const atualizarContatoSolicitacaoReservaPorTokenService = async (
  token: string,
  payload: AtualizarContatoSolicitacaoPayload
): Promise<boolean> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/contato`;

  try {
    await axios.patch(URL, payload); // sem Authorization mesmo
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const salvarAceiteTermosPorTokenService = async (
  token: string,
  payload: SalvarAceiteTermosPorTokenPayload
): Promise<SolicitacaoReservaServiceResult<SalvarAceiteTermosPorTokenResponse>> => {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/aceite-termos`;

  try {
    const response = await axios.patch(url, payload);
    const flowError = toSolicitacaoReservaFlowError(response.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    return { ok: true, data: response.data ?? {} };
  } catch (error: any) {
    const flowError = toSolicitacaoReservaFlowError(error?.response?.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.error(error);
    return { ok: false, error: null, message: extractApiMessage(error?.response?.data) };
  }
};



export const buscarResumoEstadiaByTokenService = async (
  token: string
): Promise<SolicitacaoReservaServiceResult<ResumoEstadiaByTokenResponse>> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/resumo-estadia`;

  console.log("Buscando resumo da estadia por token:", token);
  try {
    const response = await axios.get(URL, {
    });
    const flowError = toSolicitacaoReservaFlowError(response.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.log("Resposta do servidor ao buscar resumo da estadia por token:", response.data);
    return { ok: true, data: response.data };
  } catch (error: any) {
    const flowError = toSolicitacaoReservaFlowError(error?.response?.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.error(error);
    return { ok: false, error: null, message: extractApiMessage(error?.response?.data) };
  }
};

export const buscarPagamentoTaxaPorTokenService = async (
  token: string
): Promise<SolicitacaoReservaServiceResult<BuscarPagamentoTaxaByTokenResponse>> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/pagamento-taxa`;

  try {
    const response = await axios.get(URL);
    const flowError = toSolicitacaoReservaFlowError(response.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    return { ok: true, data: response.data };
  } catch (error: any) {
    const flowError = toSolicitacaoReservaFlowError(error?.response?.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.error(error);
    return { ok: false, error: null, message: extractApiMessage(error?.response?.data) };
  }
};

export const reenviarPagamentoTaxaPorTokenService = async (
  token: string
): Promise<SolicitacaoReservaServiceResult<BuscarPagamentoTaxaByTokenResponse>> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/pagamento-taxa/reenviar-link`;

  try {
    const response = await axios.post(URL);
    const flowError = toSolicitacaoReservaFlowError(response.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    return { ok: true, data: response.data };
  } catch (error: any) {
    const flowError = toSolicitacaoReservaFlowError(error?.response?.data);
    if (flowError) {
      return { ok: false, error: flowError, message: flowError.message };
    }
    console.error(error);
    return { ok: false, error: null, message: extractApiMessage(error?.response?.data) };
  }
};

export async function upsertHospedesSolicitacaoReservaPorTokenService(
  token: string,
  payload: { hospedes: any[] }
) {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/hospedes`;
  const resp = await axios.put(url, payload);
  return resp.data;
}

export async function buscarHospedesSolicitacaoReservaPorTokenService(
  token: string
): Promise<BuscarHospedesByTokenResponse | null> {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/hospedes`;
  try {
    const resp = await axios.get(url); // rota pública
    return resp.data;
  } catch (e) {
    console.error(e);
    return null;
  }
}
